import { DefaultError, useMutation, UseMutationResult } from '@tanstack/react-query';
import { cart } from '@api/apis';
import { htToast } from 'ht-styleguide';
import { IHash } from 'types/base.types';

/* utils */
import { StatusErrors } from '@constants/base';
import { deriveResponseStatus } from '@utils/object';

/* Keys */
import { Logger } from '@utils/logger';
import { queryClient } from '@integrations/reactquery';
import { cartQueryKeys } from '@store/queries/cart/queries.keys';
import { ITEM_REMOVAL_TOAST_MESSAGES } from 'src/constants/cart';

interface ISkuRemove {
  config?: IHash<any>;
}

interface RemoveSkuParams {
  idx: number;
  toastMessage?: (typeof ITEM_REMOVAL_TOAST_MESSAGES)[keyof typeof ITEM_REMOVAL_TOAST_MESSAGES];
}

const useCartMutationRemoveSku = ({ config = {} }: ISkuRemove = {}): UseMutationResult<any, DefaultError, RemoveSkuParams, unknown> =>
  useMutation({
    mutationFn: async ({ idx }: RemoveSkuParams) => {
      const response = await cart.removeItem({ itemIndex: idx, no_taxes: true });

      if (StatusErrors.has(deriveResponseStatus(response)) || response.err) throw response;

      return response.data;
    },
    onSuccess: (response, { toastMessage = ITEM_REMOVAL_TOAST_MESSAGES.DEFAULT }) => {
      /* Update Cart */
      const { cart: cartResponse = {} } = response ?? {};
      queryClient.setQueryData(cartQueryKeys.all, { ...cartResponse });
      htToast(toastMessage);
    },
    onError: error => {
      Logger('Sku Remove')(error as Error);
    },
    ...config,
  });

export default useCartMutationRemoveSku;
